import 'slick-carousel';

// Variable Declaration
const $carousel = $('#main-slider');
const $counter = $('#main-slider-counter');

$carousel.on('init reInit afterChange', (event, slick, currentSlide) => {
  const i = (currentSlide ? currentSlide : 0) + 1;

  $counter.text(`${i}/${slick.slideCount}`);
  
});


// Initialization carousel
$carousel.slick({
  centerMode: true,
  centerPadding: '0',
  cssEase: 'linear',
  fade: true,
  pauseOnFocus: false,
  pauseOnHover: false,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 8000,
  prevArrow: $('#main-slider-nav-prev'),
  nextArrow: $('#main-slider-nav-next'),
  responsive: [{
    breakpoint: 767,
    settings: {
      autoplay: false,
    }
  }]
});

if (document.querySelector('.main-slider-wrapper .virtual-tour-wrapper') !== null) {
  $(window).on('load', () => {
    document.querySelector('.virtual-tour').classList.add('ready');
  });
}
